import { motion } from "framer-motion";
import { SunMedium, Plug, BatteryCharging, Cpu, Wrench, LeafyGreen } from "lucide-react";

const services = [
  {
    icon: SunMedium,
    title: "Solar PV Installation",
    desc: "Turnkey rooftop and ground-mount systems sized to your consumption.",
  },
  {
    icon: Plug,
    title: "Electrical Installation",
    desc: "Certified residential and commercial electrical works.",
  },
  {
    icon: BatteryCharging,
    title: "Smart Energy Storage",
    desc: "High-performance lithium batteries for backup and load-shifting applications.",
  },
  { icon: Cpu, title: "Inverters", desc: "Supply of hybrid, on-grid and off-grid inverters." },
  {
    icon: Wrench,
    title: "Maintenance",
    desc: "Cleaning, performance checks and rapid response service.",
  },
  {
    icon: LeafyGreen,
    title: "Commercial Solutions",
    desc: "Offer support for commercial solar PV and battery storage systems.",
  },
];

export function Services() {
  return (
    <section id="services" className="py-24 sm:py-32 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-medium text-primary uppercase tracking-widest">
            Services
          </span>
          <h2 className="mt-3 text-4xl sm:text-5xl font-bold tracking-tight">
            Everything you need, under one roof.
          </h2>
          <p className="mt-4 text-muted-foreground text-lg">
            From the first sun ray to your wall socket — we handle design, installation, and
            lifetime support.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="group relative p-7 rounded-2xl bg-card border border-border hover:border-primary/40 transition-all hover:shadow-elegant"
            >
              <div className="grid place-items-center w-12 h-12 rounded-xl bg-primary/10 text-primary group-hover:bg-primary group-hover:text-primary-foreground transition">
                <s.icon className="w-6 h-6" />
              </div>
              <h3 className="mt-5 text-xl font-semibold">{s.title}</h3>
              <p className="mt-2 text-muted-foreground leading-relaxed">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
